// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"ae92bad8","778":"6a42f47a"}[chunkId] + ".chunk.js";
};